import React from 'react';

const Edit = (props) => (
  <i className='material-icons' {...props}>
    edit
  </i>
);

export default Edit;
